// replaces gwi svg icons with custom one
import $ from 'jquery';

export default function () {
  let gwiIconClassName = '.icon-gowatchit';

  // this is a hidden element on the page

  function replaceIcons (icons) {
    let gwiIconSvgDefinition = $('#replacementGwiIcon')[0].innerHTML;

    icons.each(function () {
      this.innerHTML = gwiIconSvgDefinition;
      this.style.backgroundImage = 'none';

      $(this).find('svg').show();
    });
  }

  window.gwiIconReplacer = setInterval(function () {
    let gwiIconsLoaded = $(gwiIconClassName);

    if (gwiIconsLoaded.length) {
      window.clearInterval(window.gwiIconReplacer);
      replaceIcons(gwiIconsLoaded);
    }
  }, 100);
}
